import { Materials } from '../interfaces/Materials';

export const transformLoadMaterials = (materials: Materials) =>
  materials.allMaterials.map(material => {
    const savedMaterial = materials.savedMaterials.find(mt => mt.matSubType === material.matSubType);
    return { ...material, ...savedMaterial, isActive: savedMaterial?.isActive || false };
  });
